const PersonDown = ({ className, width, height, x, y }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.0"
    //   viewBox="0 0 37.207 125"
    //   className={className}
    //   width={width}
    //   height={height}
    //   x={x}
    //   y={y}
    // >

    //   <circle cx="18.118" cy="8.159" r="8.159" />
    //   <path d="M8.472,95.426c0,2.524,2.05,4.574,4.574,4.574c2.529,0,4.576-2.05,4.576-4.574l0.004-38.374h2.037L19.65,95.426  c0,2.524,2.048,4.574,4.574,4.574s4.573-2.05,4.573-4.574l0.02-66.158h2.006v24.38c0,4.905,6.398,4.905,6.384,0v-24.9  c0-5.418-3.184-10.728-9.523-10.728L9.396,18.012C3.619,18.012,0,22.722,0,28.599v25.05c0,4.869,6.433,4.869,6.433,0v-24.38h2.048  L8.472,95.426z" />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 100 125"
      className={className}
      width={width}
      height={height}
      x={x}
      y={y}
    >
      <g>
        <g>
          <path d="M50.493,5.42c-5.125,0-8.843,3.718-8.843,8.843c0,5.122,3.718,8.843,8.843,8.843c5.125,0,8.842-3.722,8.842-8.843    C59.335,9.138,55.617,5.42,50.493,5.42z" />
          <path d="M59.396,26.892H40.604c-6.469,0-10.816,4.696-10.816,11.685v16.105c0,1.745,1.413,3.158,3.158,3.158    c1.745,0,3.158-1.413,3.158-3.158V38.577c0-1.391,1.135-2.523,2.527-2.523c1.394,0,2.527,1.133,2.527,2.523v53.685    c0,1.745,1.413,3.158,3.158,3.158s3.158-1.413,3.158-3.158V60.683h5.054v31.579c0,1.745,1.413,3.158,3.157,3.158    c1.745,0,3.158-1.413,3.158-3.158V38.577c0-1.391,1.133-2.523,2.527-2.523c1.392,0,2.526,1.133,2.526,2.523v16.105    c0,1.745,1.414,3.158,3.158,3.158c1.745,0,3.158-1.413,3.158-3.158V38.577C70.213,31.588,65.865,26.892,59.396,26.892z" />
        </g>
      </g>
    </svg>
  )
}

export default PersonDown
